/* assets/riwi-lp2-addons.js — Zubehoer-Add-on-Block (Bag / Couch): Verhalten.
 *
 * Herkunft: bis 17.09.2026 standen beide Module (Add-on-Block + Bestandsfilter F53b) woertlich
 * in assets/riwi-lp2.js. Owner-Feedback F2 bringt denselben Block in den Warenkorb (Drawer +
 * /cart). Der Drawer wird SITEWIDE gerendert — er darf dafuer nicht riwi-lp2.js (122 KB roh)
 * auf jede Seite ziehen. Deshalb liegt das Verhalten jetzt hier, in EINER Datei:
 *   LP2 / PDP  : sections/riwi-lp2-head.liquid laedt sie mit `defer` NACH riwi-lp2.js.
 *   Warenkorb  : assets/riwi-cart-contents.js laedt sie NACH (erst wenn ein Block im DOM steht).
 *
 * WAS SICH NICHT AENDERN DARF (und deshalb ueber einen HOST laeuft):
 * Das Modul kannte frueher die ganze Seite — Kaufform, Set-Kacheln, FREE12-/FREEBAG-Box,
 * Mengenwaehler, Sticky-Leiste. Im Warenkorb gibt es davon nichts. Statt Abfragen zu verdoppeln
 * bekommt mount() ein HOST-Objekt, das genau diese Zugriffe kapselt. Der LP2-Host unten bildet
 * die frueheren Direktzugriffe 1:1 nach; der Cart-Host liefert die Warenkorb-Variante.
 *
 * REIHENFOLGE (Teil des Vertrags, s. riwi-lp2-head.liquid):
 *   1. riwi-lp2.js  registriert FREEBAG/FREE12/Mengenwaehler-Hooks und den riwi:lp2:stock-Hoerer
 *   2. DIESE Datei  haengt den Add-on-Hook ein (Capture-Phase, also nach 1 registriert)
 *   3. ganz zuletzt laeuft der Bestandsfilter — er FEUERT riwi:lp2:stock, es muss also schon
 *      jemand zuhoeren. Bei einem sessionStorage-Treffer laeuft er synchron; umgedreht geladen
 *      ginge das Ereignis ins Leere.
 * Die frueher dokumentierte Klick-Reihenfolge (FREEBAG inline -> FREE12 -> Add-ons) bleibt
 * erhalten: beide Wachen in riwi-lp2.js pruefen window.RiwiLp2Addons zur KLICK-Zeit, nicht zur
 * Registrierungszeit, und steigen ohne preventDefault aus, sobald ein Haken gesetzt ist.
 *
 * Erfolg wird NIE per Timer erkannt — auf beiden Wegen zaehlt nur die Antwort auf cart/add.js
 * (LP2: window.RiwiLp2Cart.addAndApply, Warenkorb: window.RiwiCartContents.addAndApply).
 */
(function () {
  'use strict';

  if (window.__riwiLp2AddonsInit) return;
  window.__riwiLp2AddonsInit = true;

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var ready = function (fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  };

    /* ------------------------------------------------------- Zubehoer-Add-ons (Bag / Couch)
       Markup existiert NUR bei addon_active -> ohne [data-addons] macht dieses Modul nichts
       und die Landingpage verhaelt sich exakt wie bisher.

       Reihenfolge der Kaufpfad-Hooks auf demselben Button (alle Capture-Phase, also in
       REGISTRIERUNGS-Reihenfolge):
         1. FREEBAG  (Inline-Script der Section, laeuft schon beim Parsen)
         2. FREE12   (assets/riwi-lp2.js)
         3. Add-ons  (dieses Modul - bewusst zuletzt, jetzt in dieser eigenen Datei)
       1 und 2 steigen ohne preventDefault aus, sobald hier ein Haken gesetzt ist. Dieses Modul
       uebernimmt dann ALLES in EINEM cart/add.js: Set + Gratis-Set (FREE12) + Gratis-Bag
       (FREEBAG) + Zubehoer, und fuehrt die Codes zusammen. Zwei add.js-Aufrufe hintereinander
       waeren zwei Wahrheiten und wuerden sich beim Navigieren gegenseitig abbrechen.

       Der Zubehoer-Code haengt an der ANZAHL der Teile: Shopify-BXGY-Rabatte haben eine
       Pflichtmenge ("Customer gets quantity") - liegt weniger Zubehoer im Warenkorb als der
       Code fordert, ist er still nicht anwendbar. 1 Teil -> addon_code, 2 Teile -> addon_code_qty2. */
  function mount(host) {
      /* `scope` ist der Knoten, der den Block traegt und die Ereignisse fuehrt: auf der LP2/PDP
         die Hero-Section, im Warenkorb der .riwi-lp2-Traeger des Upsell-Blocks. Alles, was
         DARUEBER liegt (Kaufform, Set-Kacheln, FREE12-/FREEBAG-Box, Mengenwaehler), kennt dieses
         Modul nicht mehr selbst - es fragt den HOST. Die LP2-Fassung des Hosts (unten) bildet
         exakt die frueheren Direktzugriffe nach, damit sich die Landingpage nicht anders verhaelt. */
      var scope = host.scope;
      var wrap = host.wrap;

      var rows = $$('[data-addon]', wrap);
      if (!rows.length) return null;

      var CODE1 = (wrap.getAttribute('data-addon-code') || '').trim();
      var CODE2 = (wrap.getAttribute('data-addon-code2') || '').trim();
      /* ---- Festbetrag je Preisstufe (Reverse-Upsell der Farbseiten) --------------------
         FIX an = der Abzug auf das Zubehoer ist KEIN Prozentsatz, sondern ein Festbetrag,
         den die Preisstufe der gewaehlten Anker-Farbe bestimmt (Standard/Premium) und der
         optional mit der Stueckzahl der Seite waechst. Die Betraege UND die Preise nach
         Abzug kommen als fertige Geldstrings vom Server (data-ao-fix-*) - im Browser wird
         nie gerechnet und nie formatiert (der Shop fuehrt neben USD auch CAD-Maerkte).
         Der Code haengt dann an Stufe bzw. Stueckzahl statt an der Zahl der Haken. */
      var FIX = wrap.getAttribute('data-addon-fixed') === '1';
      var CODE_STD = (wrap.getAttribute('data-addon-code-std') || '').trim();
      var CODE_PRM = (wrap.getAttribute('data-addon-code-prm') || '').trim();
      var busy = false;

      /* ---- Add-on-Plan je Set (Owner-Feedback F15) -------------------------------------
         "1" = die Section hat einen Plan gerendert. Ohne Plan bleibt alles wie bisher:
         beide Zeilen immer sichtbar, Menge 1, keine Mengen-Anzeige. */
      var PLAN = wrap.getAttribute('data-addon-plan') === '1';

      /* ---- F35 (Owner 15.09.2026): Ist ein Zubehoer beim aktiven Set die GRATIS-Beigabe der
         laufenden Aktion, verschwindet seine Kaufzeile - dasselbe Produkt darf nicht zugleich
         als Geschenk und als Rabattangebot dastehen. Welche Zeile das betrifft und bei welcher
         Blockzahl, entscheidet ALLEIN der Server (data-ao-free-blocks aus dem Vergleich der
         beiden Produkt-Handles) - hier gibt es keine zweite Konfiguration. */
      var FREEANY = !!$('[data-ao-free-blocks]', wrap);

      /* ---- F28: waehlbare Stueckzahl je Zeile (Stepper). MAXQ kommt aus addon_qty_max; 1 =
         kein Stepper gerendert, dann bleibt alles wie bisher. Min ist immer 1 - die Zeile
         waehlt man ueber den Haken ab, nicht ueber die Menge 0. */
      var MAXQ = 1;
      var stepProbe = $('[data-addon-step]', wrap);
      if (stepProbe) MAXQ = parseInt(stepProbe.getAttribute('data-ao-step-max'), 10) || 1;
      if (MAXQ < 1) MAXQ = 1;
      var STEP = MAXQ > 1;

      /* data-Karte "<schluessel>:<wert>|<schluessel>:<wert>" -> Objekt. Die Werte sind fertige
         money-Strings VOM SERVER (koennen ein Tausender-Komma enthalten und haengen am Markt) -
         deshalb "|" als Trenner, und nur der ERSTE Doppelpunkt trennt Schluessel und Wert.
         Im Browser wird nie gerechnet oder formatiert, nur getauscht. */
      function parseMap(str) {
        var out = {};
        (str || '').split('|').forEach(function (pair) {
          if (!pair) return;
          var i = pair.indexOf(':');
          if (i < 1) return;
          out[pair.slice(0, i)] = pair.slice(i + 1);
        });
        return out;
      }

      var CODE_AQ = parseMap(wrap.getAttribute('data-addon-code-qty'));

      /* ---- A2 (16.09.2026): Mengenstaffel-Code des HAUPTPRODUKTS (Bag 2/3/4 Stueck) ------
         Liegt auf der Bag-ZEILE selbst, waehrend CODE_AQ oben die SET-Zeile betrifft - zwei
         Produktrabatte auf verschiedenen Zeilen sind kombinierbar, auf DERSELBEN Zeile
         waeren sie es nicht. Eigene, kleine Karte statt eines Aufrufs in das Stepper-Modul:
         dieses Modul darf unabhaengig vom Mengenwaehler laufen (addon_active ohne
         qty_picker) und umgekehrt. */
      var qtyPickerRoot = host.qtyPickerRoot ? host.qtyPickerRoot() : null;
      var QTY_TIER_CODE = qtyPickerRoot ? parseMap(qtyPickerRoot.getAttribute('data-qty-map')) : {};
      function qtyStaffelCode(n) {
        var raw = QTY_TIER_CODE[String(n)] || '';
        return raw.split(':')[0] || '';
      }

      /* Stueckzahl des Produkts DIESER Seite. Sie steht in der Kaufform - dieselbe Zahl, die
         in den Warenkorb geht. Kein eigener Zaehler, also auch keine zweite Wahrheit, wenn
         die Seite spaeter einen Mengenwaehler bekommt. */
      function anchorQty() { return host.anchorQty(); }
      /* Preisstufe der aktiven Farbe. Sie steht am gewaehlten Swatch (data-tier), gesetzt vom
         Server aus dem Katalog - im Theme steht kein Preis und keine Farbliste. */
      function currentTier() { return host.currentTier(); }

      function showError(msg) { host.showError(msg); }
      function clearError() { host.clearError(); }

      function checkbox(row) { return $('[data-addon-check]', row); }
      /* row.hidden zaehlt mit: eine Zeile, die der Plan fuer das aktive Set ausblendet, darf
         auch dann nicht in den Warenkorb wandern, wenn ihr Haken noch gesetzt waere. */
      function isOn(row) { var c = checkbox(row); return !!(c && c.checked && !row.hidden); }
      function anyOn() {
        for (var i = 0; i < rows.length; i++) { if (isOn(rows[i])) return true; }
        return false;
      }

      /* ---- Farbwahl je Add-on: gleiche Bauart wie die Gratis-Bag (radiogroup + Pfeiltasten).
         Preise werden NICHT gerechnet, sondern als fertige money-Strings vom Server getauscht -
         nur Liquid kennt den aktiven Markt (USD vs. CAD). */
      rows.forEach(function (row) {
        var swatches = $$('[data-ao-swatch]', row);
        var colors = $('[data-addon-colors]', row);
        var wasEl = $('[data-addon-was]', row);
        var nowEl = $('[data-addon-now]', row);
        var chosenEl = $('[data-addon-chosen]', row);
        /* W29-.us: im Warenkorb (addon_color_name_in_label) steht der Name INLINE im Label statt
           in der eigenen chosen-Zeile - dort gibt es kein [data-addon-chosen], dafuer dieses
           Element. PDP/LP2 haben es nicht (Markup unveraendert), $() liefert dann null und die
           Zuweisung unten ist ein No-op - keine zweite Farb-Logik, nur ein zweites Ziel. */
        var chosenLabelEl = $('[data-addon-color-name]', row);
        var qtyEl = $('[data-addon-qty]', row);
        var stepN = $('[data-addon-step-n]', row);
        var stepBtns = $$('[data-addon-step-d]', row);
        var cb = checkbox(row);
        /* F35: Blockzahl, bei der genau dieses Zubehoer gratis dazukommt. 0 = betrifft die
           Zeile nie (Couch, oder Aktion aus). */
        var FREEB = parseInt(row.getAttribute('data-ao-free-blocks'), 10) || 0;

        /* Zustand dieser Zeile: welche Menge gilt gerade (n) und welche Preis-Karten gehoeren
           zur gewaehlten Farbe. Beim Laden stehen die Karten der vorgewaehlten Farbe an der
           Zeile selbst - Zeilen ohne zweite lieferbare Farbe haben gar keine Swatches. */
        var st = {
          qty: parseMap(row.getAttribute('data-ao-qty')),     /* Blockzahl -> Menge (Plan) */
          was: parseMap(row.getAttribute('data-ao-was-q')),   /* Menge -> Streichpreis */
          now: parseMap(row.getAttribute('data-ao-now-q')),   /* Menge -> Aktionspreis */
          n: parseInt(row.getAttribute('data-ao-qty-init'), 10) || 1
        };
        if (st.n > MAXQ) st.n = MAXQ;

        /* Festbetrags-Karten dieser Zeile: "<Stufe>-<Stueckzahl>" -> fertiger Geldstring.
           Fehlt ein Eintrag, bleibt der ausgelieferte Text stehen - lieber der Preis von
           eben als ein im Browser gerechneter. */
        var fixNow = parseMap(row.getAttribute('data-ao-fix-now'));
        var fixOff = parseMap(row.getAttribute('data-ao-fix-off'));
        var offEl = $('[data-addon-off]', row);
        row.__aoFix = function (tier, aq) {
          var key = (tier === 'prm' ? 'prm' : 'std') + '-' + (aq || 1);
          if (nowEl && fixNow[key]) nowEl.textContent = fixNow[key];
          if (offEl && fixOff[key]) offEl.textContent = '\u2212' + fixOff[key];
        };

        /* Sichtbare Menge + Preise neu schreiben. Fehlt zur Menge ein Server-Preis, bleibt der
           alte Text stehen - lieber ein Preis von eben als ein im Browser gerechneter. */
        function priceOut() {
          var key = String(st.n);
          if (qtyEl) qtyEl.textContent = ((PLAN || STEP) && st.n > 1) ? (st.n + '\u00d7\u00a0') : '';
          if (stepN) stepN.textContent = String(st.n);
          if (wasEl && st.was[key]) wasEl.textContent = st.was[key];
          if (nowEl && st.now[key]) nowEl.textContent = st.now[key];
          stepBtns.forEach(function (b) {
            var d = parseInt(b.getAttribute('data-addon-step-d'), 10) || 0;
            b.disabled = (d < 0 && st.n <= 1) || (d > 0 && st.n >= MAXQ);
          });
        }

        /* Mengenwechsel: EIN Weg fuer Klick und Set-Wechsel. Der Preis kommt aus der
           Server-Karte (Menge -> money-String); fehlt zur Menge ein Eintrag, bleibt der alte
           Text stehen - lieber ein Preis von eben als ein im Browser gerechneter. */
        function setQty(n) {
          if (!(n >= 1)) n = 1;
          if (n > MAXQ) n = MAXQ;
          if (n === st.n) return;
          st.n = n;
          priceOut();
          /* F53b: Die Menge entscheidet mit, welche Farben ueberhaupt noch lieferbar sind. */
          if (row.__aoStock) row.__aoStock();
        }
        stepBtns.forEach(function (b) {
          b.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            setQty(st.n + (parseInt(b.getAttribute('data-addon-step-d'), 10) || 0));
          });
        });

        /* F29: Der Produktlink liegt IM <label>. Ohne stopPropagation wuerde der Klick ueber
           die Label-Zuordnung zusaetzlich den Haken umschalten - der Kunde oeffnet die
           Produktseite und haette nebenbei ungefragt Zubehoer ausgewaehlt. Kein
           preventDefault: der Link soll navigieren. */
        $$('[data-addon-link]', row).forEach(function (a) {
          a.addEventListener('click', function (e) { e.stopPropagation(); });
        });

        function paint(btn) {
          if (!btn) return;
          row.setAttribute('data-addon-variant', btn.getAttribute('data-variant-id') || '');
          var mw = parseMap(btn.getAttribute('data-was-q'));
          var mn = parseMap(btn.getAttribute('data-now-q'));
          var hasMap = false;
          for (var k in mn) { if (Object.prototype.hasOwnProperty.call(mn, k)) { hasMap = true; break; } }
          st.was = hasMap ? mw : { '1': btn.getAttribute('data-was') || '' };
          st.now = hasMap ? mn : { '1': btn.getAttribute('data-now') || '' };
          var colorName = btn.getAttribute('data-color-name') || '';
          if (chosenEl) chosenEl.textContent = colorName;
          if (chosenLabelEl) chosenLabelEl.textContent = colorName;
          priceOut();
        }
        function pick(btn) {
          swatches.forEach(function (b) {
            var on = b === btn;
            b.setAttribute('aria-checked', on ? 'true' : 'false');
            b.tabIndex = on ? 0 : -1;
          });
          paint(btn);
        }
        swatches.forEach(function (btn) {
          btn.addEventListener('click', function () { pick(btn); });
          btn.addEventListener('keydown', function (e) {
            var d = 0;
            if (e.key === 'ArrowRight' || e.key === 'ArrowDown') d = 1;
            else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') d = -1;
            else if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); pick(btn); return; }
            if (!d) return;
            e.preventDefault();
            var i = swatches.indexOf(btn);
            var next = swatches[(i + d + swatches.length) % swatches.length];
            pick(next);
            if (next.focus) next.focus();
          });
        });
        var pre = null;
        swatches.forEach(function (b) { if (!pre && b.getAttribute('aria-checked') === 'true') pre = b; });
        if (pre) paint(pre);

        /* ---- F53b: Farben, von denen im Markt-Lager weniger liegt als die gewaehlte Menge,
           verschwinden aus der Reihe. data-qty setzt das Bestands-Modul (Storefront-API,
           marktbezogen); OHNE das Attribut wird nicht gefiltert - Fehlerfall = heutiger Stand.
           Trifft es die aktive Farbe, rueckt die naechste lieferbare nach: eine unsichtbare
           Auswahl waere schlimmer als gar keine, sie ginge stillschweigend in den Warenkorb.
           Bleibt keine Farbe uebrig, geht der Haken zurueck und die Zeile ist nicht mehr
           waehlbar - mit einer Zeile Begruendung, sonst wirkt sie kaputt. */
        var noteEl = null;
        function stockNote(on) {
          var txt = scope.getAttribute('data-sfinv-note') || '';
          if (!on) { if (noteEl) noteEl.hidden = true; return; }
          if (!txt) return;
          if (!noteEl) {
            noteEl = document.createElement('p');
            noteEl.className = 'addon-stock-note';
            noteEl.setAttribute('role', 'status');
            noteEl.textContent = txt;
            row.appendChild(noteEl);
          }
          noteEl.hidden = false;
        }
        function stockOk(btn, n) {
          var raw = btn.getAttribute('data-qty');
          if (raw === null || raw === '') return true;
          var q = parseInt(raw, 10);
          return isNaN(q) ? true : q >= n;
        }
        function applyStock() {
          if (!swatches.length) return;
          var n = (PLAN || STEP) ? (st.n || 1) : 1;
          var vis = [], cur = null;
          swatches.forEach(function (b) {
            var ok = stockOk(b, n);
            b.hidden = !ok;
            if (ok) vis.push(b);
            if (b.getAttribute('aria-checked') === 'true') cur = b;
          });
          if (!vis.length) {
            if (cb) { if (cb.checked) { cb.checked = false; syncCheck(); } cb.disabled = true; }
            row.classList.add('is-nostock');
            stockNote(true);
            return;
          }
          if (cb) cb.disabled = false;
          row.classList.remove('is-nostock');
          stockNote(false);
          if (!cur || cur.hidden) pick(vis[0]);
        }
        row.__aoStock = applyStock;
        scope.addEventListener('riwi:lp2:stock', applyStock);

        /* Die Farbreihe erscheint erst mit dem Haken: ungefragt vier Farbkreise unter jedem
           Zubehoer waeren mehr Entscheidung, als der Kaufpfad an dieser Stelle vertraegt.
           Als eigene Funktion, damit ein programmatisches Zuruecksetzen (Set-Wechsel) denselben
           Weg geht wie ein Klick - kein synthetisches change-Event noetig. */
        function syncCheck() {
          var on = !!(cb && cb.checked);
          row.classList.toggle('is-on', on);
          if (colors) colors.hidden = !on;
        }
        if (cb) cb.addEventListener('change', syncCheck);

        /* ---- Set-Wechsel (nur mit Plan): Menge und Sichtbarkeit dieser Zeile nachziehen.
           Ohne Reload, ohne zweite Preisrechnung - die Preise kommen aus den Server-Karten.
           Bietet der Plan dieses Zubehoer beim neuen Set NICHT an, geht ein gesetzter Haken
           zurueck: sonst laege Zubehoer im Warenkorb, das die Seite fuer dieses Set gar nicht
           mehr zeigt. */
        row.__aoApply = function (blocks) {
          /* F35 hat Vorrang vor dem Plan: beim Gratis-Set ist die Zeile weg, egal welche
             Menge der Plan dort vorsaehe. Ein gesetzter Haken geht dabei zurueck - sonst
             laege die Bag doppelt im Warenkorb (einmal gratis, einmal gekauft). */
          /* blocks kommt beim Ereignis aus dem dataset und ist dann ein STRING ("24") -
             deshalb erst in eine Zahl wandeln, sonst schluege der Vergleich immer fehl. */
          var free = FREEB > 0 && (parseInt(blocks, 10) || 0) === FREEB;
          if (!PLAN) {
            if (!FREEB) return;
            if (free && cb && cb.checked) { cb.checked = false; syncCheck(); }
            row.hidden = free;
            return;
          }
          var q = parseInt(st.qty[String(blocks)], 10);
          if (free || !(q > 0)) {
            if (cb && cb.checked) { cb.checked = false; syncCheck(); }
            row.hidden = true;
            return;
          }
          row.hidden = false;
          /* F28: Der Set-Wechsel setzt die Stueckzahl auf den Plan-Wert ZURUECK - eine am
             vorigen Set eingestellte Menge gilt fuer das neue Set nicht weiter. */
          if (q > MAXQ) q = MAXQ;
          st.n = q;
          priceOut();
          if (row.__aoStock) row.__aoStock();
        };
        /* Menge fuer den Warenkorb - EINE Quelle, dieselbe wie die angezeigte. */
        row.__aoQty = function () { return (PLAN || STEP) ? (st.n || 1) : 1; };

        /* Startzustand einmal ausschreiben: ohne Plan laeuft applyBlocks nie, der Stepper
           braucht seine Knoepfe aber trotzdem im richtigen Zustand (Minus bei 1 aus). */
        priceOut();
      });

      /* Der Set-Wechsel kommt ueber dasselbe Ereignis wie bei Sticky-Leiste und FREE12-Box
         (riwi:lp2:variant) - kein zweiter Klick-Handler auf den Kacheln, keine zweite Wahrheit.
         Der A/B-Arm wird ganz am Ende von ready() angewendet und feuert dieses Ereignis
         ebenfalls, die Mengen stimmen also auch im Testarm. */
      function applyBlocks(blocks) {
        rows.forEach(function (r) { if (r.__aoApply) r.__aoApply(blocks); });
      }
      if (PLAN || FREEANY) {
        scope.addEventListener('riwi:lp2:variant', function (e) {
          var b = (e && e.detail && e.detail.blocks) || currentBlocks();
          applyBlocks(b);
        });
        applyBlocks(currentBlocks());
      }

      /* Festbetrags-Modus: der Farbwechsel kann die Preisstufe wechseln - Abzug und Preis
         nach Abzug werden dann neu aus den Server-Karten gesetzt. Dasselbe Ereignis wie
         ueberall sonst, kein zweiter Klick-Handler auf den Swatches. */
      function applyFix() {
        var tier = currentTier(), aq = anchorQty();
        rows.forEach(function (r) { if (r.__aoFix) r.__aoFix(tier, aq); });
      }
      if (FIX) {
        scope.addEventListener('riwi:lp2:variant', applyFix);
        applyFix();
      }

      function currentBlocks() { return host.currentBlocks(); }

      function combinedAdd(btn) {
        if (busy) return;
        var aq = anchorQty();
        var picks = [];
        rows.forEach(function (row) {
          if (!isOn(row)) return;
          var id = parseInt(row.getAttribute('data-addon-variant'), 10) || 0;
          /* Menge aus dem Plan (z. B. 2 Bags beim 24er). STORE20/X2/X3 sind Basic-Rabatte
             OHNE Pflichtmenge (Admin-API 14.09.2026) - sie greifen auf jede Stueckzahl, die
             Code-Wahl haengt also weiter an der ZAHL DER HAKEN, nicht an der Stueckzahl. */
          if (id) picks.push({ id: id, quantity: row.__aoQty ? row.__aoQty() : 1 });
        });
        /* A2: kein Haken ist jetzt ein gueltiger Fall - der Haupt-Mengenwaehler kann diesen
           Pfad AUCH ohne Zubehoer ausloesen (Bag x3 + BAGQTY-3, kein Set dazu). hook() prueft
           das VOR dem Aufruf; hier bleibt der Notnagel fuer den Fall, dass gar nichts greift. */
        /* Anker-Position(en): auf der LP2/PDP das Produkt DIESER Seite mal Stueckzahl
           (host.baseItems liefert null, wenn keine Varianten-ID dasteht - dann brechen wir ab
           wie frueher bei `!setId`). Im Warenkorb gibt es keinen Anker zum Mitlegen: das Set
           LIEGT schon im Korb, host.baseItems() ist dort eine leere Liste. */
        var items = host.baseItems(aq);
        if (items === null) return;
        if (!picks.length && !qtyStaffelCode(aq)) return;
        var codes = [];
        var drop = [];
        var blocks = currentBlocks();

        /* Leitcode = der Zubehoer-Code (SET-Zeile). Er steht zuerst, weil er der Grund fuer
           diesen Pfad war, bevor es den Mengenwaehler gab. Ohne Haken gibt es keinen. */
        var accCode = '';
        if (picks.length) {
          accCode = picks.length >= 2 ? CODE2 : CODE1;
          /* Festbetrags-Modus: nicht die Zahl der Haken entscheidet, sondern die Stueckzahl der
             Seite (Mengen-Staffel) und, wenn dafuer kein Code hinterlegt ist, die Preisstufe der
             gewaehlten Farbe. Ohne passenden Code geht der Warenkorb OHNE Code raus - lieber
             kein Rabatt als ein Code, der nicht greift und den Kunden im Checkout enttaeuscht. */
          if (FIX) {
            accCode = CODE_AQ[String(aq)]
              || (currentTier() === 'prm' ? CODE_PRM : CODE_STD)
              || '';
          }
          if (accCode) codes.push(accCode);
        }
        /* A2: Mengenstaffel-Code des HAUPTPRODUKTS (Bag-ZEILE) - liegt auf einer ANDEREN Zeile
           als accCode (Set-Zeile), beide Codes sind also gleichzeitig gueltig. */
        var qCode = qtyStaffelCode(aq);
        if (qCode) codes.push(qCode);

        /* FREE12 und FREEBAG bleiben unveraendert gueltig - ihre Konfiguration wird nur
           GELESEN (dieselben Boxen, dieselben Bedingungen wie in ihren Modulen). Sie haengen an
           der Seite, nicht am Bauteil, also liefert sie der HOST. Reihenfolge wie frueher:
           erst Zubehoer-/Staffel-Code, dann die Gratis-Codes; erst Anker + Zugaben, dann picks. */
        var ex = host.extras ? host.extras(blocks) : null;
        if (ex) {
          if (ex.items && ex.items.length) items = items.concat(ex.items);
          if (ex.codes && ex.codes.length) codes = codes.concat(ex.codes);
          if (ex.drop && ex.drop.length) drop = drop.concat(ex.drop);
        }

        items = items.concat(picks);

        busy = true;
        clearError();
        var wasDisabled = btn.disabled;
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        var release = function () { busy = false; btn.disabled = wasDisabled; btn.removeAttribute('aria-busy'); };

        host.submit({
          tag: host.tag || 'riwi-lp2 addons',
          items: items,
          codes: codes,
          dropIfCodeFails: drop,
          onError: function (msg) { release(); showError(msg); },
          /* riwi-us-cart-redesign P2: s. promoAdd oben. Deckt Buybox, Store-Modal und
             Bundle ab — alle drei rufen combinedAdd(). */
          onSuccess: release
        });
      }

      /* Erfolgspfad laesst busy/disabled stehen und navigiert. Nach ZURUECK (bfcache) waere der
         Zustand eingefroren und der Button tot -> auf pageshow freigeben, aber nur was WIR
         markiert haben (ein echt ausverkaufter Button bleibt deaktiviert). */
      window.addEventListener('pageshow', function () {
        busy = false;
        if (host.releaseOnPageshow) host.releaseOnPageshow();
      });

      function hook(btn) {
        if (!btn || btn.__aoHooked) return;
        btn.__aoHooked = true;
        btn.addEventListener('click', function (e) {
          /* A2: ohne Haken UND ohne Staffel-Code fuer die aktuelle Menge bleibt es beim
             nativen Formular (bisheriges Verhalten, auch mit Mengenwaehler auf 1 oder auf
             einer Stufe ohne Code). */
          if (!anyOn() && !qtyStaffelCode(anchorQty())) return;
          /* Ohne fetch NICHT abfangen: dann laeuft das native Formular und wenigstens das Set
             landet im Warenkorb. Lieber ein Zubehoer weniger als ein leerer Korb. */
          if (typeof window.fetch !== 'function') return;
          if (busy) { e.preventDefault(); e.stopImmediatePropagation(); return; }
          e.preventDefault();
          e.stopImmediatePropagation();
          combinedAdd(btn);
        }, true);
      }
      /* Wer den Kauf ausloest, weiss nur der Host: auf der LP2 sind es die vorhandenen
         Add-to-cart-Knoepfe (abgefangen in der Capture-Phase), im Warenkorb ein eigener
         Knopf, der nichts abzufangen hat und direkt combinedAdd() ruft. */
      host.bindTriggers({ hook: hook, run: combinedAdd, active: anyOn, busy: function () { return busy; } });

      /* `handles` = "dieses Modul faengt den naechsten Klick ab" - WOERTLICH dieselbe
         Bedingung wie in hook() unten. Die anderen Kaufpfad-Module in assets/riwi-lp2.js
         fragen danach, bevor sie selbst uebernehmen. `active` (nur Haken) bleibt unveraendert:
         FREE12 und FREEBAG haben immer genau danach gefragt. */
      return {
        active: anyOn,
        handles: function () { return anyOn() || !!qtyStaffelCode(anchorQty()); },
        run: combinedAdd
      };
  }

    /* --------------------------------------- F53b: mengenbewusster Bestandsfilter (Owner 15.09.2026)
       PROBLEM: Die Farbfelder zeigen alle Farben, die beim SEITENAUFBAU lieferbar waren. Wer
       den Stepper auf 3 stellt, kann eine Farbe waehlen, von der nur 2 im Markt-Lager liegen -
       der Checkout ueberverkauft, oder /cart/add.js antwortet mit 422, nachdem der Kunde die
       Entscheidung schon getroffen hat.
       QUELLE: Storefront-API `productVariant.quantityAvailable` mit `@inContext(country: XX)`.
       Nur diese Zahl ist MARKTBEZOGEN. `variant.inventory_quantity` in Liquid waere die Summe
       ueber ALLE Standorte (Texas + Ungarn + Kanada) und damit fuer .us schlicht falsch:
       gemessen 15.09.2026 hat "Dark Grey - 2444" (Bag) im US-Markt 0 Stueck, im CA-Markt 56.
       WARUM IM BROWSER und nicht in Liquid: die Seite wird serverseitig gecacht, ein in Liquid
       gerenderter Bestand waere beim Ausliefern schon alt. Der Abruf laeuft einmal je Seite,
       gebuendelt fuer ALLE Varianten beider Picker, und liegt fuer 5 Minuten in sessionStorage.
       FEHLERFALL = HEUTIGES VERHALTEN: kein Token, kein Land, Fetch scheitert, Antwort
       unbrauchbar -> es wird nichts gefiltert. Der Bestandsfilter ist Komfort, das Netz bleibt
       die Antwort des Warenkorbs. */
  /* F2 (17.09.2026): frueher fest auf `[data-riwi-lp2-hero][data-sfinv]`. Jetzt laeuft der
     Filter je TRAEGER-KNOTEN mit data-sfinv - auf der LP2/PDP ist das genau die Hero-Section
     (unveraendertes Verhalten), im Warenkorb der .riwi-lp2-Traeger des Add-on-Blocks. */
  function stockFilter(hero) {
      if (!hero || !window.fetch) return;
      if (hero.__sfinvDone) return;
      hero.__sfinvDone = true;
      var sfinv = (hero.getAttribute('data-sfinv') || '').trim();
      var shop = (hero.getAttribute('data-sfinv-shop') || '').trim();
      var country = (hero.getAttribute('data-sfinv-country') || '').trim().toUpperCase();
      /* Der Platzhalter aus dem Repo-Template ist KEIN Token: die echte Zeichenkette setzt
         erst das Deploy-Script aus der .env ein. Wird ungeloest deployt, bleibt das Feature
         aus statt eine sinnlose Anfrage zu schicken. */
      if (!sfinv || sfinv.indexOf('@env:') === 0) return;
      if (!/^[A-Z]{2}$/.test(country)) return;
      /* Bestands-Worker (riwi-stock-worker, 21.10.2026): data-sfinv traegt die Worker-Basis-URL
         (https://…workers.dev) statt eines Storefront-Tokens - der Token bleibt serverseitig im
         Worker. Steht dort noch ein Token, laeuft der alte Storefront-Pfad (Rollback = nur die
         Liquid-Zeile/Section-Einstellung zuruecksetzen, kein JS-Deploy). */
      var workerUrl = /^https:\/\/[a-z0-9.-]+\/?$/i.test(sfinv) ? sfinv.replace(/\/+$/, '') : '';
      if (!workerUrl && /^[a-z]+:/i.test(sfinv)) return;   /* URL, aber keine gueltige Worker-URL -> aus */
      var token = workerUrl ? '' : sfinv;
      if (!workerUrl && !/^[a-z0-9-]+\.myshopify\.com$/.test(shop)) return;

      var sws = $$('[data-ao-swatch],[data-fb-swatch],[data-cv-swatch]', hero);
      var ids = [], seen = {};
      sws.forEach(function (b) {
        var id = (b.getAttribute('data-variant-id') || '').trim();
        if (!/^[0-9]{6,}$/.test(id) || seen[id]) return;
        seen[id] = 1; ids.push(id);
      });
      if (!ids.length) return;

      var KEY = 'riwi:sfinv:' + country + ':' + ids.join(',');
      var TTL = 300000; /* 5 Minuten - lang genug fuer eine Sitzung, kurz genug, dass eine
                           leergekaufte Farbe nicht den ganzen Besuch ueber waehlbar bleibt. */

      function store(get, val) {
        try {
          if (!window.sessionStorage) return null;
          if (get) {
            var raw = window.sessionStorage.getItem(KEY);
            if (!raw) return null;
            var o = JSON.parse(raw);
            return (o && o.t && (Date.now() - o.t) < TTL && o.q) ? o.q : null;
          }
          window.sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), q: val }));
        } catch (err) { /* privater Modus / voller Speicher: dann eben ohne Cache */ }
        return null;
      }

      /* Die Mengen landen als data-qty AM SWATCH - so bleibt der Zustand dort, wo die
         Auswahl-Logik ohnehin hinschaut, und jedes Modul filtert selbst. */
      function apply(map) {
        var any = false;
        sws.forEach(function (b) {
          var id = (b.getAttribute('data-variant-id') || '').trim();
          if (!Object.prototype.hasOwnProperty.call(map, id)) return;
          b.setAttribute('data-qty', String(map[id]));
          any = true;
        });
        if (!any) return;
        try {
          hero.dispatchEvent(new CustomEvent('riwi:lp2:stock', { detail: { country: country } }));
        } catch (err) {
          var ev = document.createEvent('CustomEvent');
          ev.initCustomEvent('riwi:lp2:stock', false, false, { country: country });
          hero.dispatchEvent(ev);
        }
      }

      var cached = store(true);
      if (cached) { apply(cached); return; }

      if (workerUrl) {
        /* Max. 30 IDs je Anfrage (Worker-Grenze, sonst 400). Teile laufen parallel; nur wenn
           ALLE gelingen, wird gefiltert. Fehler/403/429/503/Timeout (3,5 s; der Worker gibt
           nach 3 s selbst 503) = heutiges Verhalten: nichts filtern. Antwort { "<id>": n },
           n = lieferbar, vom Worker auf 20 gedeckelt (= Stepper-Maximum). */
        var chunks = [];
        for (var c = 0; c < ids.length; c += 30) chunks.push(ids.slice(c, c + 30));
        var timer = null;
        var timeout = new Promise(function (res) { timer = setTimeout(function () { res('timeout'); }, 3500); });
        Promise.race([
          Promise.all(chunks.map(function (part) {
            return fetch(workerUrl + '/stock?ids=' + part.join(',') + '&country=' + country, {
              method: 'GET', credentials: 'omit', mode: 'cors'
            }).then(function (r) { return r.ok ? r.json() : null; });
          })),
          timeout
        ]).then(function (parts) {
          if (timer) clearTimeout(timer);
          if (!parts || parts === 'timeout') return;
          var map = {};
          for (var k = 0; k < parts.length; k++) {
            var p = parts[k];
            if (!p || typeof p !== 'object') return;   /* ein Teil kaputt -> gar nicht filtern */
            for (var id in p) {
              if (!Object.prototype.hasOwnProperty.call(p, id)) continue;
              var q = p[id];
              if (/^[0-9]+$/.test(id) && typeof q === 'number' && q >= 0) map[id] = q;
            }
          }
          if (!Object.keys(map).length) return;
          store(false, map);
          apply(map);
        }).catch(function () { /* kein Filter = heutiges Verhalten */ });
        return;
      }

      var gids = ids.map(function (i) { return 'gid://shopify/ProductVariant/' + i; });
      var query = 'query($ids:[ID!]!) @inContext(country: ' + country + ') { nodes(ids:$ids)'
        + ' { ... on ProductVariant { id availableForSale quantityAvailable } } }';
      fetch('https://' + shop + '/api/2025-07/graphql.json', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': token },
        body: JSON.stringify({ query: query, variables: { ids: gids } })
      }).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
        var nodes = d && d.data && d.data.nodes;
        if (!nodes || !nodes.length) return;
        var map = {};
        nodes.forEach(function (n) {
          if (!n || !n.id) return;
          var id = String(n.id).split('/').pop();
          /* quantityAvailable ist null, wenn der Haendler die Bestandsanzeige nicht
             freigegeben hat. Dann NICHT auf 0 raten - die Farbe bleibt unbeschraenkt.
             Ausverkauft im Markt (availableForSale=false) heisst dagegen hart 0. */
          var q = (typeof n.quantityAvailable === 'number') ? n.quantityAvailable : null;
          if (n.availableForSale === false) q = 0;
          if (q === null) return;
          map[id] = q < 0 ? 0 : q;
        });
        if (!Object.keys(map).length) return;
        store(false, map);
        apply(map);
      }).catch(function () { /* kein Filter = heutiges Verhalten */ });
  }

  /* ------------------------------------------------------------------ HOST A: LP2 / PDP
     Bildet die frueheren Direktzugriffe des Moduls nach — Zeile fuer Zeile dieselben
     Selektoren und Bedingungen wie vor der Auslagerung. Aendert sich hier etwas, aendert
     sich das Verhalten der Landingpage; genau deshalb steht es an EINER Stelle. */
  function mountHero() {
    var hero = $('[data-riwi-lp2-hero]');
    if (!hero) return;
    var wrap = $('[data-addons]', hero);
    if (!wrap) return;
    var idInput = $('input[data-variant-id]', hero);
    var errWrap = $('.product-form__error-message-wrapper', hero);
    var errMsg = errWrap ? $('.product-form__error-message', errWrap) : null;

    var api = mount({
      scope: hero,
      wrap: wrap,
      tag: 'riwi-lp2 addons',
      qtyPickerRoot: function () { return $('[data-hero-qty]', hero); },
      /* Stueckzahl des Produkts DIESER Seite. Sie steht in der Kaufform - dieselbe Zahl, die
         in den Warenkorb geht. Kein eigener Zaehler, also auch keine zweite Wahrheit. */
      anchorQty: function () {
        var qEl = idInput && idInput.form ? idInput.form.querySelector('[name="quantity"]') : null;
        var n = qEl ? (parseInt(qEl.value, 10) || 1) : 1;
        return n < 1 ? 1 : n;
      },
      /* Preisstufe der aktiven Farbe. Sie steht am gewaehlten Swatch (data-tier), gesetzt vom
         Server aus dem Katalog - im Theme steht kein Preis und keine Farbliste. */
      currentTier: function () {
        var a = $('.variant.active', hero);
        return (a && a.getAttribute('data-tier') === 'prm') ? 'prm' : 'std';
      },
      currentBlocks: function () {
        var a = $('.variant.active', hero);
        return a ? (parseInt(a.getAttribute('data-blocks'), 10) || 0) : 0;
      },
      showError: function (msg) { if (errMsg && errWrap) { errMsg.textContent = msg; errWrap.hidden = false; } },
      clearError: function () { if (errWrap) { errWrap.hidden = true; if (errMsg) errMsg.textContent = ''; } },
      /* null = abbrechen (frueher: `if (!setId) return;`). */
      baseItems: function (aq) {
        var setId = idInput && idInput.value ? parseInt(idInput.value, 10) : 0;
        if (!setId) return null;
        return [{ id: setId, quantity: aq }];
      },
      extras: function (blocks) {
        var items = [], codes = [], drop = [];
        var f12 = $('[data-f12-box]', hero);
        if (f12) {
          var fMin = parseInt(f12.getAttribute('data-f12-min'), 10) || 0;
          var fExtra = parseInt(f12.getAttribute('data-f12-extra'), 10) || 0;
          var fCode = (f12.getAttribute('data-f12-code') || '').trim();
          if (fExtra > 0 && fMin > 0 && blocks >= fMin) {
            items.push({ id: fExtra, quantity: 1 });
            if (fCode) { codes.push(fCode); drop.push({ code: fCode, id: fExtra }); }
          }
        }
        var fb = $('[data-fb-box]', hero);
        if (fb && !fb.hidden) {
          var bBlocks = parseInt(fb.getAttribute('data-fb-blocks'), 10) || 0;
          var bCode = (fb.getAttribute('data-fb-code') || '').trim();
          var sw = $('[data-fb-swatch][aria-checked="true"]', fb);
          var bagId = sw ? (parseInt(sw.getAttribute('data-variant-id'), 10) || 0) : 0;
          if (bBlocks && blocks === bBlocks && bagId && bCode) {
            items.push({ id: bagId, quantity: 1 });
            codes.push(bCode);
            drop.push({ code: bCode, id: bagId });
          }
        }
        return { items: items, codes: codes, drop: drop };
      },
      /* EINE Stelle fuer den Warenkorb-Weg: window.RiwiLp2Cart aus assets/riwi-lp2.js. Fehlt
         die Datei (JS-Fehler), passiert NICHTS - dann laeuft das native Formular weiter, weil
         der Hook unten ohne Cart gar nicht erst abfaengt. */
      submit: function (opts) {
        if (!window.RiwiLp2Cart) { opts.onError('Something went wrong — please try again.'); return; }
        window.RiwiLp2Cart.addAndApply(opts);
      },
      releaseOnPageshow: function () {
        $$('[data-atc], [data-sticky-btn]').forEach(function (b) {
          if (b && b.getAttribute('aria-busy') === 'true') {
            b.disabled = false;
            b.removeAttribute('aria-busy');
          }
        });
      },
      bindTriggers: function (t) {
        t.hook($('[data-atc]', hero));
        /* Die Sticky-Leiste haengt spaeter im Body-Portal - dokumentweit suchen. */
        t.hook($('[data-sticky-btn]'));
      }
    });
    /* Flagge fuer die beiden Wachen in riwi-lp2.js (FREE12-Box und Mengenwaehler). Sie fragen
       zur KLICK-Zeit, nicht zur Registrierungszeit - die spaetere Datei ist also unschaedlich. */
    if (api) window.RiwiLp2Addons = { active: api.active, handles: api.handles };
  }

  /* ------------------------------------------------------------------ HOST B: Warenkorb
     F2 (Owner 17.09.2026). Im Warenkorb gibt es keinen Anker zum Mitlegen (das Set LIEGT
     schon drin), keine Kaufform, keine Set-Kacheln und keine Gratis-Boxen — die bedient
     weiterhin riwi-cart-contents.js (Gift-Stage). Dieses Modul liefert nur das Zubehoer.
     Der Erfolgspfad ist die gefaehrliche Stelle: hier wird NICHT navigiert. Nach dem Add
     meldet riwi-cart-contents.js den neuen Stand (Section-Refetch), der Drawer bleibt offen. */
  function mountCartBlocks() {
    $$('[data-rc-addons-scope]').forEach(function (scope) {
      if (scope.__aoMounted) return;
      var wrap = $('[data-addons]', scope);
      if (!wrap) return;
      scope.__aoMounted = true;
      /* Knopf und Fehlerzeile stehen NEBEN dem Traeger, nicht darin: der Traeger ist der
         .riwi-lp2-Scope (nur das Bauteil), die Karte darum herum gehoert dem Warenkorb-Stil
         (.riwi-cart__upsell). Innerhalb des Traegers gesucht faende man sie nie. */
      var card = (scope.closest && scope.closest('.riwi-cart__upsell')) || scope.parentNode || scope;
      var cta = $('[data-rc-addons-add]', card);
      var errEl = $('[data-rc-addons-error]', card);
      var blocks = parseInt(scope.getAttribute('data-rc-blocks'), 10) || 0;
      var box = scope.closest ? scope.closest('[data-riwi-cart]') : null;

      mount({
        scope: scope,
        wrap: wrap,
        tag: 'riwi-cart addons',
        qtyPickerRoot: function () { return null; },
        anchorQty: function () { return 1; },
        currentTier: function () { return 'std'; },
        /* Blockzahl des GROESSTEN Sets im Warenkorb — serverseitig ermittelt, damit Plan und
           Anzeige aus derselben Quelle kommen wie die Preise. */
        currentBlocks: function () { return blocks; },
        showError: function (msg) { if (errEl) errEl.textContent = msg || ''; },
        clearError: function () { if (errEl) errEl.textContent = ''; },
        /* Kein Anker: das Set liegt bereits im Warenkorb. Leere Liste, kein null — null hiesse
           "abbrechen". */
        baseItems: function () { return []; },
        extras: function () { return null; },
        submit: function (opts) {
          if (!window.RiwiCartContents || !box) { opts.onError('Something went wrong — please try again.'); return; }
          window.RiwiCartContents.addAndApply(box, {
            items: opts.items,
            codes: opts.codes,
            dropIfCodeFails: opts.dropIfCodeFails,
            onError: opts.onError
          });
          /* Kein onSuccess-Aufruf hier: addAndApply ersetzt im Erfolgsfall den ganzen
             [data-riwi-cart]-Knoten (Section-Refetch) — dieser Block samt Knopf ist dann weg.
             Ein Zuruecksetzen des busy-Zustands liefe auf einem detached Element. */
        },
        releaseOnPageshow: function () {
          if (cta && cta.getAttribute('aria-busy') === 'true') {
            cta.disabled = false;
            cta.removeAttribute('aria-busy');
          }
        },
        bindTriggers: function (t) {
          if (!cta) return;
          /* W34-.us (30.09.2026, Owner-Hypothese): ein grosser ausgegrauter Knopf VOR dem Haken
             sah wie ein defekter Checkout-Button aus. Der Knopf bleibt jetzt ganz WEG, solange
             kein Haken gesetzt ist (hidden), nicht nur deaktiviert - erst der erste Haken macht
             ihn sichtbar UND klickbar in einem Schritt. Serverseitig startet er hidden+disabled
             im Markup, damit das auch ohne JS stimmt (der Knopf hat ohnehin kein Formular und
             keinen href - ohne JS war er schon vorher kein Kaufweg). */
          var syncCta = function () {
            var on = t.active();
            cta.disabled = !on;
            cta.hidden = !on;
          };
          wrap.addEventListener('change', syncCta);
          wrap.addEventListener('click', syncCta);
          scope.addEventListener('riwi:lp2:stock', syncCta);
          syncCta();
          cta.addEventListener('click', function (e) {
            e.preventDefault();
            if (t.busy() || cta.disabled) return;
            t.run(cta);
          });
        }
      });
    });
  }

  function boot() {
    mountHero();
    mountCartBlocks();
    /* IMMER zuletzt: der Filter FEUERT riwi:lp2:stock, die Hoerer muessen stehen. */
    $$('[data-sfinv]').forEach(stockFilter);
  }

  ready(boot);
  /* Nach jedem Section-Swap des Warenkorbs steht ein NEUER Block im DOM (der alte ist weg).
     riwi-cart-contents.js meldet das mit riwi-cart:updated. */
  document.addEventListener('riwi-cart:updated', function () {
    mountCartBlocks();
    $$('[data-sfinv]').forEach(stockFilter);
  });

  window.RiwiLp2AddonsCore = { mount: mount, mountCartBlocks: mountCartBlocks };
})();
